export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.7-0857.51",
  commitId: "eed76f832fd5daaf6262409c40c4ba2857acbf3c",
  commitTime: "2026-05-07T08:57:51.000Z",
});
